import { DateTime } from 'luxon';
import { useQuery } from '@tanstack/react-query';
import { fetchCampaignList } from 'api/campaign';

export const useInvoicesFiltersOptions = () => {
  const { data: campaignQueryData } = useQuery({
    queryKey: ['campaigns'],
    queryFn: fetchCampaignList,
  });

  const campaignsList = campaignQueryData?.campaigns ?? [];

  const campaignDefaultOption = { label: 'Alle Kampagnen', value: 'all' };
  const periodDefaultOption = { label: 'Alle Daten', value: 'all' };

  const campaignOptions = [
    campaignDefaultOption,
    ...campaignsList.map((campaign) => ({ label: campaign.name, value: campaign.id })),
  ];

  const prevYear = DateTime.now().minus({ year: 1 });

  const periodOptions = [
    periodDefaultOption,
    {
      label: 'Letzte 30 Tage',
      value: `${DateTime.now().minus({ month: 1 }).toISODate()}--${DateTime.now().toISODate()}`,
    },
    { label: 'Aktuelles Jahr', value: `${DateTime.now().startOf('year').toISODate()}--${DateTime.now().toISODate()}` },
    {
      label: prevYear.toFormat('yyyy'),
      value: `${prevYear.startOf('year').toISODate()}--${prevYear.endOf('year').toISODate()}`,
    },
  ];

  return { campaignDefaultOption, periodDefaultOption, campaignOptions, periodOptions };
};
